import api from "@/lib/api";

const KEY = "helium_cookie_consent";

export function getConsent() {
  return localStorage.getItem(KEY);
}

export function analyticsAllowed() {
  return getConsent() === "all";
}

export async function track(path) {
  if (!analyticsAllowed()) return;
  const params = new URLSearchParams(window.location.search);
  let source = params.get("src") || params.get("utm_source") || params.get("ref") || "";
  if (source) sessionStorage.setItem("helium_src", source);
  else source = sessionStorage.getItem("helium_src") || "";
  let referrer = "";
  try { referrer = document.referrer ? new URL(document.referrer).hostname : ""; } catch { /* ignore */ }
  try {
    await api.post("/analytics/track", { type: "pageview", path, source, referrer });
  } catch {
    /* analytics is best-effort; never block the UI */
  }
}
